export default __webpack_public_path__ + "static/SR France - Origin - Statement-abd752fefe53839c43f328344bafd8d6.pdf";